import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {VisitPlanStatusEnum} from "../../../enums/visit-plan-status.enum";
import {
  VisitPlanScheduleStatusColorMap,
  VisitPlanScheduleStatusEnum
} from "../../../enums/visit-plan-schedule-status.enum";

require('./visit-plan-card-info.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-card-info',
  templateUrl: './visit-plan-card-info.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanCardInfoComponent implements OnInit, OnChanges {

  @Input() visitPlan: VisitPlanModel;
  @Output() onDeleteVisitPlan = new EventEmitter<VisitPlanModel>();
  @Output() onEditVisitPlan = new EventEmitter<VisitPlanModel>();
  @Output() onRestoreVisitPlan = new EventEmitter<VisitPlanModel>();
  @Output() onCreateVisitPlan = new EventEmitter<VisitPlanModel>();

  public visitPlanStatusColor: string;
  public visitPlanStatuses: typeof VisitPlanStatusEnum = VisitPlanStatusEnum;
  public visitPlanScheduleStatus: typeof VisitPlanScheduleStatusEnum = VisitPlanScheduleStatusEnum;

  constructor() {
  }

  ngOnInit() {
    this._setCardStatusColor();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.visitPlan && !changes.visitPlan.isFirstChange()) {
      this._setCardStatusColor();
    }
  }

  private _setCardStatusColor() {
    this.visitPlanStatusColor = VisitPlanScheduleStatusColorMap[this.visitPlan.scheduleStatus || VisitPlanScheduleStatusEnum.NOT_PLANNED];
  }

}
